/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectIntegrationResourceData } from './CrmProjectIntegrationResourceData';
import {
    CrmProjectIntegrationResourceDataFromJSON,
    CrmProjectIntegrationResourceDataFromJSONTyped,
    CrmProjectIntegrationResourceDataToJSON,
    CrmProjectIntegrationResourceDataToJSONTyped,
} from './CrmProjectIntegrationResourceData';

/**
 * 
 * @export
 * @interface CrmProjectIntegrationData
 */
export interface CrmProjectIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationData
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectIntegrationData
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectIntegrationData
     */
    authorizationSuccessful?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectIntegrationData
     */
    paused?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationData
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectIntegrationData
     */
    removedAt?: Date | null;
    /**
     * 
     * @type {Array<CrmProjectIntegrationResourceData>}
     * @memberof CrmProjectIntegrationData
     */
    resources?: Array<CrmProjectIntegrationResourceData>;
}

/**
 * Check if a given object implements the CrmProjectIntegrationData interface.
 */
export function instanceOfCrmProjectIntegrationData(value: object): value is CrmProjectIntegrationData {
    return true;
}

export function CrmProjectIntegrationDataFromJSON(json: any): CrmProjectIntegrationData {
    return CrmProjectIntegrationDataFromJSONTyped(json, false);
}

export function CrmProjectIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'createdAt': json['createdAt'] === undefined ? undefined : json['createdAt'] === null ? null : (new Date(json['createdAt'])),
        'authorizationSuccessful': json['authorizationSuccessful'] === undefined ? undefined : json['authorizationSuccessful'] === null ? null : json['authorizationSuccessful'],
        'paused': json['paused'] === undefined ? undefined : json['paused'] === null ? null : json['paused'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'removedAt': json['removedAt'] === undefined ? undefined : json['removedAt'] === null ? null : (new Date(json['removedAt'])),
        'resources': json['resources'] == null ? undefined : ((json['resources'] as Array<any>).map(CrmProjectIntegrationResourceDataFromJSON)),
    };
}

export function CrmProjectIntegrationDataToJSON(json: any): CrmProjectIntegrationData {
    return CrmProjectIntegrationDataToJSONTyped(json, false);
}

export function CrmProjectIntegrationDataToJSONTyped(value?: CrmProjectIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'authorizationSuccessful': value['authorizationSuccessful'],
        'paused': value['paused'],
        'status': value['status'],
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
        'resources': value['resources'] == null ? undefined : ((value['resources'] as Array<any>).map(CrmProjectIntegrationResourceDataToJSON)),
    };
}

